module.exports = __webpack_public_path__ + "media/images/logo-ford-9bee136dae1d69884a626c175e30b2a9.svg";